import {ButtonLink, CheckmarkIcon, CsvFileIcon, PdfFileSmallIcon} from '@modifi/ui'
import download from 'downloadjs'
import PropTypes from 'prop-types'
import React, {Component} from 'react'

import {
  ProgressButtonContent,
  ProgressButtonSuccess,
  StyledProgressButton,
  transitionDelay,
  transitionPeriod,
} from './styles'

export default class DownloadButton extends Component {
  static propTypes = {
    type: PropTypes.oneOf(['pdf', 'csv']),
    invoice: PropTypes.shape({
      externalInvoiceId: PropTypes.string.isRequired,
      invoiceNumber: PropTypes.string.isRequired,
    }),
    onClick: PropTypes.func.isRequired,
  }

  static defaultProps = {
    type: 'pdf',
    invoice: {},
  }

  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      successStart: false,
      successEnd: false,
      blocked: false,
    }
    this.handleClick = this.handleClick.bind(this)
  }

  handleClick() {
    this.setState({loading: true, blocked: true})
    const {type, invoice, onClick} = this.props
    onClick(type, invoice.externalInvoiceId)
      .then(([fileName, blob]) => {
        if (blob) {
          download(blob, fileName || `${invoice.invoiceNumber}.${type}`, blob.type)
        }
        this.setState({loading: false, successStart: true})
        setTimeout(
          () => this.setState({successEnd: true}),
          transitionPeriod + transitionDelay + 200
        )
        setTimeout(
          () => this.setState({successStart: false, successEnd: false, blocked: false}),
          3 * transitionPeriod
        )
      })
      .catch(() => {
        // render error message
        this.setState({loading: false, blocked: false})
      })
  }

  render() {
    const {type, invoice, onClick, ...restProps} = this.props
    const {loading, successStart, successEnd, blocked} = this.state
    const iconMap = {
      pdf: PdfFileSmallIcon,
      csv: CsvFileIcon,
    }
    const Icon = iconMap[type]
    return (
      <StyledProgressButton
        buttonComponent={ButtonLink}
        onClick={this.handleClick}
        loading={loading}
        successStart={successStart}
        successEnd={successEnd}
        active={!blocked}
        icon
        {...restProps}
      >
        <ProgressButtonContent>
          <Icon height={16} width={16} />
          <span>{type}</span>
        </ProgressButtonContent>
        <ProgressButtonSuccess>
          <CheckmarkIcon height={16} width={16} />
        </ProgressButtonSuccess>
      </StyledProgressButton>
    )
  }
}
